import api from "@/lib/axios";

/** The size is signed into the upload URL, so it must be the exact byte length of what gets PUT. */
export const getProfilePictureUploadUrl = async (ext: string, size: number) => {
  const res = await api.get("/users/profile-picture-url", { params: { ext, size } });
  return res.data; // { uploadUrl, fileUrl }
};

export const updateProfilePicture = async (imageUrl: string) => {
  await api.patch("/users/profile-picture", { imageUrl });
};

export type AcquisitionSourcePayload =
  | { status: "answered"; source: string; detail?: string }
  | { status: "skipped" };

export const submitAcquisitionSource = async (payload: AcquisitionSourcePayload) => {
  await api.patch("/users/acquisition-source", payload);
};

export const getUserBillingInfo = async () => {
  try {
    const res = await api.get("/users/billing");
    return { success: true, data: res.data.data };
  } catch (error: unknown) {
    const err = error as { response?: { data?: { message?: string } }; message?: string };
    return {
      success: false,
      error: err.response?.data?.message || err.message || "Unknown error",
    };
  }
};
